import { BackButton, StyledText } from "../../../../components/common";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import spin_icon from "../../../../components/images/spin_icon.png";

const SpinTheWheelTips = () => {
  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingInline: 15,
          backgroundColor: "white",
        }}
      >
        <StyledText style={{ marginTop: -1, fontSize: 24 }}>
          Spin the wheel
        </StyledText>
        <BackButton onClick={() => history.goBack()} />
        <div style={{ alignSelf: "center" }}>
          <img width={100} src={spin_icon} />
        </div>
        <div>
          <StyledText style={{ fontSize: 22, fontFamily: "MTNMedium" }}>
            What is Spin the wheel?
          </StyledText>
        </div>
        <StyledText
          style={{
            fontFamily: "MTNMedium",
          }}
        >
          Hey, fam! MTN Pulse is hooking you up with the ultimate spin-off
          experience tailored just for you! Just join in the MTN Pulse SPIN THE
          WHEEL Contest – it's lit!
        </StyledText>

        <OutlinedContainer color={background}>
          <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
            Tips
          </StyledText>

          {tips.map((note, index) => {
            return (
              <TipsContainer key={index}>
                <CircleContainer>
                  <Dot color={background} />
                </CircleContainer>
                <StyledText
                  style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                >
                  {note}
                </StyledText>
              </TipsContainer>
            );
          })}
        </OutlinedContainer>
        <div
          style={{
            marginTop: "7%",
            marginBottom: "7%",
            fontFamily: "MTNRegular",
          }}
        >
          <a
            style={{ fontFamily: "MTNBold", textDecoration: "underline" }}
            onClick={() => history.push("/privacy")}
          >
            Terms & Condition
          </a>{" "}
          apply
        </div>
      </div>
    </div>
  );
};

export default SpinTheWheelTips;

const OutlinedContainer = styled.div`
  width: "90%";
  border-width: 2;
  border: 1.5px solid ${({ color }) => color};
  border-radius: 15px;
  padding-inline: 10px;
`;

const TipsContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const tips = [
  "Please note! This promo does not require any MoMo activity before or after.",
  "Ready to take a spin? Tap or click to see what awesome prize you'll score!",
  "Whether it's a device or data giveaways, there's something dope to grab!",
  "Stay glued to your screen for notifications about your reward. Don't miss out!",
  "Redeem your reward hassle-free! Pick the nearest MTN Office and track your delivery status right on the Pulse section of myMTN App",
  "Keep the vibe alive with one spin per day. The season of love fun never stops!",
  "Don't sleep on it, prizes are flying off the shelves, so keep spinning while you can!",
  "Peep your spin history to see your past wins and keep tabs on your haul!",
  "Happy spinning, fam!",
];
